/** Vehicle card copy helpers — leaf module for listing view models. */

import { AVAILABILITY_STATUS } from "../constants/automapListingConstants.js";

export function getUnknownAttributeLabel(t) {
  return t("automotive.attributeUnknown");
}

export function formatCardAvailabilityStatus(status, t) {
  if (!t) return status || "";
  const key = status ? `automotive.card.availability.${status}` : null;
  if (key) {
    const value = t(key);
    if (value && value !== key) return value;
  }
  return t("automotive.detail.layout.availabilityFallback");
}

export function formatCardFreshnessLabel(listing = {}, t) {
  const { lastConfirmedAt, availabilityStatus } = listing;

  if (availabilityStatus === AVAILABILITY_STATUS.PENDING_CONFIRMATION) {
    return t("automotive.card.freshnessPendingConfirmation");
  }

  if (lastConfirmedAt) {
    const ts = new Date(lastConfirmedAt).getTime();
    if (!Number.isNaN(ts)) {
      const ageDays = (Date.now() - ts) / (24 * 3_600_000);
      if (ageDays <= 7) {
        return t("automotive.card.freshnessRecentlyUpdated");
      }
    }
  }

  if (availabilityStatus === AVAILABILITY_STATUS.AVAILABLE) {
    return t("automotive.card.freshnessAvailable");
  }

  if (!availabilityStatus || availabilityStatus === AVAILABILITY_STATUS.UNKNOWN) {
    return t("automotive.card.freshnessToConfirm");
  }

  return t("automotive.card.freshnessToConfirm");
}

export function formatCardLastConfirmed(date, t, locale = "es-CO") {
  if (!date) return t("automotive.card.freshnessToConfirm");
  const ts = new Date(date).getTime();
  if (Number.isNaN(ts)) return t("automotive.card.freshnessToConfirm");
  const hours = Math.round((Date.now() - ts) / 3_600_000);
  if (hours <= 1) return t("automotive.card.confirmedToday");
  if (hours < 24) return t("automotive.card.confirmedHoursAgo", { hours });
  const days = Math.round(hours / 24);
  if (days === 1) return t("automotive.card.confirmedYesterday");
  if (days < 7) return t("automotive.card.confirmedDaysAgo", { days });
  return new Date(date).toLocaleDateString(locale);
}
